import { validationCheckFields } from './validationFields'
import ExpandedRowDetails from '../Shared/ExpandedRowDetails'

/**
 * ExpandedRow wrapper for GroupEligibility (Type 2)
 * Uses the common ExpandedRow component with type-specific validation fields
 * Does not check processStatus (shows validation results regardless)
 */
export default function ExpandedRow({ data }) {
    return (
        <ExpandedRowDetails
            data={data}
            validationCheckFields={validationCheckFields}
            shouldCheckProcessStatus={true}
            processErrorField="lastFailedError"
        />
    )
}
